import React from "react"
import { firestore } from "../../core"
import { useJoiningSpaces, useMySpaces } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import { User } from "firebase/auth"
import { UserId } from "popopo-msg"
import { Paths } from "../../paths"

export const SpaceList = (props: { firebase: User }) => {
  const spacesMine = useMySpaces(firestore, UserId(props.firebase.uid), 100)
  const spacesJoining = useJoiningSpaces(firestore, UserId(props.firebase.uid), 100)

  return (
    <>
      <h4>My spaces</h4>
      <div>
        <ul className="list-group w-100">
          {spacesMine === "loading" ? (
            <li>
              <i className="fas fa-spin fa-spinner" />
            </li>
          ) : spacesMine.length === 0 ? (
            <li>あなたがオーナーのスペースは1つも存在しません。</li>
          ) : (
            spacesMine.map((space) => (
              <li key={space.id} className="list-group-item">
                <NavLink to={Paths.spaces.space.getPath(space.id)}>ID: {space.id}</NavLink>
              </li>
            ))
          )}
        </ul>
      </div>

      <h4>Joining spaces</h4>
      <div>
        <ul className="list-group w-100">
          {spacesJoining === "loading" ? (
            <li>
              <i className="fas fa-spin fa-spinner" />
            </li>
          ) : spacesJoining.length === 0 ? (
            <li>参加しているスペースは1つも存在しません。</li>
          ) : (
            spacesJoining.map((spaceUser) => (
              <li key={spaceUser.spaceKey} className="list-group-item">
                <NavLink to={Paths.spaces.space.getPath(spaceUser.spaceKey)}>
                  ID: {spaceUser.spaceKey}(Role: {spaceUser.role})
                </NavLink>
              </li>
            ))
          )}
        </ul>
      </div>
    </>
  )
}
